(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-bundle-builder"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const container = document.querySelector('.mokira-bundle-container');
  if(!container) return;
  const radios = container.querySelectorAll('input[type="radio"]');
  const totalPriceDisplay = container.querySelector('#mokira-bundle-total-display');
  const addBtn = container.querySelector('#mokira-add-bundle-btn');

  function calculateBundleTotal() {
    let total = 0;
    let selectedCount = 0;

    radios.forEach(radio => {
      if(radio.checked) {
        total += parseFloat(radio.getAttribute('data-price')) || 0;
        selectedCount++;
      }
    });

    totalPriceDisplay.textContent = "$" + total.toFixed(2);

    if(selectedCount === 3) {
      addBtn.removeAttribute('disabled');
    } else {
      addBtn.setAttribute('disabled', 'true');
    }
  }

  radios.forEach(radio => radio.addEventListener('change', calculateBundleTotal));

  addBtn.addEventListener('click', function() {
    let itemsArray = [];
    radios.forEach(radio => {
      if(radio.checked) {
        itemsArray.push({ id: parseInt(radio.value), quantity: 1 });
      }
    });

    addBtn.innerText = "Adding to Box...";
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itemsArray })
    })
    .then(response => response.json())
    .then(data => {
       addBtn.innerText = "Success!";
window.location.href = '/cart';
})
.catch((error) => {
console.error('Error:', error);
addBtn.innerText = "Assemble & Add Gift Box to Cart";
});
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-product-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.gpsShowcaseInit) return;
    window.gpsShowcaseInit = true;

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[data-gps-ajax="true"]')) return;

      event.preventDefault();

      var button = form.querySelector('button[type="submit"]');
      var originalLabel = button ? button.textContent : '';
      var addedLabel = form.getAttribute('data-added-label') || originalLabel;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      if (button) button.disabled = true;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return response.json();
        })
        .then(function (item) {
          if (button) button.textContent = addedLabel;
          document.dispatchEvent(new CustomEvent('gps:cart-add', { bubbles: true, detail: { item: item } }));
          setTimeout(function () {
            if (button) {
              button.textContent = originalLabel;
              button.disabled = false;
            }
          }, 2200);
        })
        .catch(function () {
          if (button) button.disabled = false;
          form.removeAttribute('data-gps-ajax');
          form.submit();
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
